import React from "react";
import PropTypes from "prop-types";

const BackButton = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.365424 6.80078C0.20805 6.63753 0.120117 6.41962 0.120117 6.19288C0.120117 5.96613 0.20805 5.74822 0.365424 5.58497L5.09767 0.679684L6.35826 1.89637L2.90938 5.4711H12.7252V7.22299H3.20723L6.30658 10.436L5.04599 11.6526L0.365424 6.80078Z"
        fill={fill}
      />
    </svg>
  );
};

BackButton.defaultProps = {
  width: 13,
  height: 12,
  fill: "white",
};

export default BackButton;
